import { Component, HostListener, Input } from '@angular/core';

@Component({
    selector: 'app-offer-miniature',
    templateUrl: './offer-miniature.component.html',
    styleUrls: ['./offer-miniature.component.sass'],
    standalone: false
})

export class OfferMiniatureComponent {

  @Input() title = '';
  @Input() backgroundImg = 'assets/images/offer_new_dialogys.svg';
  arrowColor = 'black';
  @Input() link = '';
  @Input() description = 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Placeat, itaque quibusdam ';

  constructor() { }
  
  onMouseEnter() {
    this.arrowColor = 'white';
  }
  
  onMouseLeave() {
    this.arrowColor = 'black';
  }
    
}